export const getEnvironment = () => {
    const host = window.location.hostname;
    let env = 'production';

    if (host === 'ibe.test.meinschiff.com') {
        env = 'test';
    } else if (host === 'tuic-ibe-web.dev.jakala.services') {
        env = 'dev';
    } else if (host === 'localhost' || host === 'tuic-ibe' || host === '127.0.0.1' || host === 'tuic-ibe-v') {
        env = 'local';
    }

    return env;
};
